import { render } from "./FooterPrincipal.vue?vue&type=template&id=25148e6e"
import script from "./FooterPrincipal.vue?vue&type=script&lang=js"
export * from "./FooterPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__